import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex" }

import { shareInfo } from '@dc-platform/dc-interaction'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import type { FormInstance } from 'ant-design-vue'
import { ref, computed, onMounted } from 'vue'
import UploadFile from '@/components/UploadFile'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { fetchUsersByWorkCode } from '@/api/common'
import type { LbuSaleCoachingEditParams } from '@/typings/api/saleCoaching'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'

import {
  saleCoachingCreate,
  saleCoachingDetail,
  saleCoachingUpdate,
  saleCoachingReview,
  saleCoachingConfirm
} from '@/api/yuntuSales/saleCoaching'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import dayjs from 'dayjs'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'baseMessage',
  props: {
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  view: {
    type: Boolean
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'comment', 'review', 'view'].includes(value)
    }
  }
},
  emits: ['update:detail', 'getDetail'],
  setup(__props, { emit: __emit }) {

const router = useRouter()

const dataForm = ref<LbuSaleCoachingEditParams>({})
const formRef = ref<FormInstance>()
const loading = ref(false)
const route = useRoute()
const props = __props

onMounted(() => {
  fetch()

  if (props.type === 'add') {
    if (dataForm.value.indicatorInfo === undefined) {
      dataForm.value.indicatorInfo = [{}]
    }

    if (dataForm.value.actionPlanInfo === undefined) {
      dataForm.value.actionPlanInfo = [{}]
    }
  }
})

const permissionPage = computed(() => {
  if (props.type === 'add') {
    return { save: 'lbu_sale_coaching_add_btn' }
  } else if (props.type === 'edit') {
    return { save: 'lbu_sale_coaching_edit_btn' }
  } else if (props.type === 'review') {
    return { save: 'lbu_sale_coaching_review_btn' }
  } else {
    return {}
  }
})

const handleIndicatorInfoAdd = () => {
  dataForm.value.indicatorInfo?.push({})
}
const handleIndicatorInfoDel = (index: number) => {
  dataForm.value.indicatorInfo?.splice(index, 1)
}

const handleActionPlanInfoAdd = () => {
  dataForm.value.actionPlanInfo?.push({})
}
const handleActionPlanInfoDel = (index: number) => {
  dataForm.value.actionPlanInfo?.splice(index, 1)
}

const handleReviewAdd = () => {
  dataForm.value.reviewInfo?.push({})
}
const handleReviewDel = (index: number) => {
  dataForm.value.reviewInfo?.splice(index, 1)
}

const emit = __emit
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    saleCoachingDetail({ id: route.query.id })
      .then((res) => {
        if (props.type === 'review') {
          if (!res.data.reviewTime) {
            res.data.reviewTime = dayjs().format('YYYY/MM/DD HH:mm:ss')
          }

          if (!res.data.reviewInfo) {
            res.data.reviewInfo = res.data.actionPlanInfo?.length ? res.data.actionPlanInfo?.map((item) => ({
              actionPlan: item.actionPlan
            })) : [{}]
          }
        }

        dataForm.value = res.data ? res.data : {}

        emit('getDetail', res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}

const handleMentorChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const handleTraineeChange = (val: any) => {
  if (val && props.type === 'add') {
    const employeeList = [val]
    fetchUsersByWorkCode({ employeeList }).then((res) => {
      const [followerInfo] = res.data
      if (followerInfo && followerInfo.lbuCustomerRegion != null) {
        dataForm.value.traineeRegion = followerInfo.lbuCustomerRegion
      } else {
        dataForm.value.traineeRegion = undefined
        setTimeout(() => formRef.value?.clearValidate('traineeRegion'))
      }
    })
  }
}

const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.lbuCustomerRegion != null) {
      dataForm.value.mentorRegion = followerInfo.lbuCustomerRegion
    } else {
      dataForm.value.mentorRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('mentorRegion'))
    }

    if (followerInfo && followerInfo.managerNo != null) {
      dataForm.value.ccTo = [`${followerInfo.managerNo}`]
    }
  })
}

const confirmRow = () => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      saleCoachingConfirm({ id: route.query.id }).then(() => {
        DcMessage.success('操作成功')
        goBack()
      })
    }
  })
}

const reviewRow = () => {
  router.push({
    path: '/lbu/saleCoaching/review',
    query: {
      id: route.query.id
    }
  })
}

const commentRow = () => {
  router.push({
    path: '/lbu/saleCoaching/comment',
    query: {
      id: route.query.id
    }
  })
}

const editRow = () => {
  router.push({
    path: '/lbu/saleCoaching/edit',
    query: {
      id: route.query.id
    }
  })
}

const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = {
      ...dataForm.value
    }
    try {
      if (props.type === 'edit') {
        await saleCoachingUpdate(p)
        DcMessage.success('编辑成功')
      } else if (props.type === 'add') {
        await saleCoachingCreate(p)
        DcMessage.success('新增成功')
      } else if (props.type === 'review') {
        await saleCoachingReview(p)
        DcMessage.success('回顾成功')
      }
      goBack()
    } catch (error) {}
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      model: dataForm.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: "基础信息",
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "辅导人",
              name: "mentor",
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  permission: "",
                  disabled: true,
                  value: dataForm.value.mentor,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.mentor) = $event)),
                  defaultValue: "me",
                  onChange: handleMentorChange,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "辅导人区域" }, {
              default: _withCtx(() => [
                _createVNode(CustomerAreaCascader, {
                  appId: "cos_lbu",
                  value: dataForm.value.mentorRegion,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.mentorRegion) = $event)),
                  disabled: true,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "本次辅导时间",
              rules: [{ required: true, message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  startTime: dataForm.value.tutoringTime,
                  "onUpdate:startTime": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.tutoringTime) = $event)),
                  defaultValue: "now",
                  isRange: false,
                  view: __props.view
                }, null, 8, ["startTime", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "下次辅导时间",
              name: "nextTutoringTime",
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  startTime: dataForm.value.nextTutoringTime,
                  "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.value.nextTutoringTime) = $event)),
                  isRange: false,
                  view: __props.view
                }, null, 8, ["startTime", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "被辅导人",
              name: "trainee",
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  permission: "",
                  value: dataForm.value.trainee,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.value.trainee) = $event)),
                  onChange: handleTraineeChange,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "被辅导人区域" }, {
              default: _withCtx(() => [
                _createVNode(CustomerAreaCascader, {
                  appId: "cos_lbu",
                  value: dataForm.value.traineeRegion,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.value.traineeRegion) = $event)),
                  disabled: true,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "重点关注指标" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.value.focusArea,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.value.focusArea) = $event)),
                  maxlength: 200,
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "关注指标和项目",
          span: 6
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(MultipleItem, { view: __props.view }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.value.indicatorInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '指标和项目',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['indicatorInfo', index, 'indicatorsAndProjects'],
                      rules: { required: true, message: '请输入' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: item.indicatorsAndProjects,
                          "onUpdate:value": ($event: any) => ((item.indicatorsAndProjects) = $event),
                          maxlength: 200,
                          placeholder: "请输入",
                          view: __props.view
                        }, null, 8, ["value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '当前进度状态详情',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['indicatorInfo', index, 'progressStatus'],
                      rules: { required: true, message: '请输入' }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_CosInput, {
                            value: item.progressStatus,
                            "onUpdate:value": ($event: any) => ((item.progressStatus) = $event),
                            maxlength: 200,
                            placeholder: "请输入",
                            view: __props.view
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (props.isEdit && dataForm.value.indicatorInfo && dataForm.value.indicatorInfo.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (handleIndicatorInfoDel(index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 2
        }, [
          (props.isEdit)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (handleIndicatorInfoAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1024),
        _createVNode(_component_dc_layout_card, {
          title: "行动计划",
          span: 6
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(MultipleItem, { view: __props.view }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.value.actionPlanInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '设定目标和截止时间',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['actionPlanInfo', index, 'settingGoals'],
                      rules: { required: true, message: '请输入' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: item.settingGoals,
                          "onUpdate:value": ($event: any) => ((item.settingGoals) = $event),
                          maxlength: 200,
                          placeholder: "请输入",
                          view: __props.view
                        }, null, 8, ["value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '行动方案',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['actionPlanInfo', index, 'actionPlan'],
                      rules: { required: true, message: '请输入' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: item.actionPlan,
                          "onUpdate:value": ($event: any) => ((item.actionPlan) = $event),
                          maxlength: 200,
                          placeholder: "请输入",
                          view: __props.view
                        }, null, 8, ["value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '目标客户',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['actionPlanInfo', index, 'targetCustomer'],
                      rules: { required: true, message: '请输入' }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_CosInput, {
                            value: item.targetCustomer,
                            "onUpdate:value": ($event: any) => ((item.targetCustomer) = $event),
                            maxlength: 200,
                            placeholder: "请输入",
                            view: __props.view
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (props.isEdit && dataForm.value.actionPlanInfo && dataForm.value.actionPlanInfo.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (handleActionPlanInfoDel(index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_a_col, { span: 6 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"]),
            _createVNode(_component_dc_form_item, {
              label: "附件上传",
              name: "fileId",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  value: dataForm.value.fileId,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.value.fileId) = $event)),
                  valueType: "array",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              span: 24,
              label: "备注"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  maxlength: 2000,
                  placeholder: "请输入",
                  value: dataForm.value.remark,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.value.remark) = $event)),
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "抄送人",
              name: "ccTo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  permission: "",
                  value: dataForm.value.ccTo,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.value.ccTo) = $event)),
                  mode: "multiple",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            })
          ]),
          _: 2
        }, [
          (props.isEdit)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (handleActionPlanInfoAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1024),
        (props.type === 'review' || dataForm.value.reviewInfo != undefined)
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 0,
              title: "回顾",
              span: 6
            }, {
              subTitle: _withCtx(() => [
                (!((__props.view && props.type === 'comment') || props.type === 'view'))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      ghost: "",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (handleReviewAdd()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_dc_form_item, {
                  label: "回顾时间",
                  name: "reviewTime",
                  rules: [{ required: true, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosSingleDateTimePicker, {
                      defaultValue: "now",
                      startTime: dataForm.value.reviewTime,
                      "onUpdate:startTime": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.value.reviewTime) = $event)),
                      disabled: true,
                      isRange: false,
                      view: (__props.view && props.type === 'comment') || props.type === 'view'
                    }, null, 8, ["startTime", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(MultipleItem, {
                  view: (__props.view && props.type === 'comment') || props.type === 'view'
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.value.reviewInfo, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _createVNode(_component_dc_form_item, {
                          label: index ? '' : '行动方案',
                          class: _normalizeClass(index ? 'no-form-label' : ''),
                          name: ['reviewInfo', index, 'actionPlan'],
                          rules: { required: true, message: '请输入' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.actionPlan,
                              "onUpdate:value": ($event: any) => ((item.actionPlan) = $event),
                              maxlength: 200,
                              placeholder: "请输入",
                              view: (__props.view && props.type === 'comment') || props.type === 'view'
                            }, null, 8, ["value", "onUpdate:value", "view"])
                          ]),
                          _: 2
                        }, 1032, ["label", "class", "name"]),
                        _createVNode(_component_dc_form_item, {
                          label: index ? '' : '行动结果',
                          class: _normalizeClass(index ? 'no-form-label' : ''),
                          name: ['reviewInfo', index, 'actionResults'],
                          rules: { required: true, message: '请输入' }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_CosInput, {
                                value: item.actionResults,
                                "onUpdate:value": ($event: any) => ((item.actionResults) = $event),
                                maxlength: 200,
                                placeholder: "请输入",
                                view: (__props.view && props.type === 'comment') || props.type === 'view'
                              }, null, 8, ["value", "onUpdate:value", "view"]),
                              (!((__props.view && props.type === 'comment') || props.type === 'view') && dataForm.value.reviewInfo && dataForm.value.reviewInfo.length > 1)
                                ? (_openBlock(), _createBlock(_component_a_button, {
                                    key: 0,
                                    type: "text",
                                    danger: "",
                                    style: {"padding":"0 0 0 12px"},
                                    onClick: ($event: any) => (handleReviewDel(index))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("删除")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "class", "name"]),
                        _createVNode(_component_a_col, { span: 12 })
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["view"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, {
      value: dataForm.value,
      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm).value = $event)),
      formRef: formRef.value
    }, {
      default: _withCtx(() => [
        (props.type === 'add' || props.type === 'edit' || props.type === 'review')
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (handleSubmit())),
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["loading"])), [
              [_directive_permission, permissionPage.value.save]
            ])
          : _createCommentVNode("", true),
        (props.type === 'view' && dataForm.value.status !== 2)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "primary",
              onClick: editRow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 编辑 ")
              ]),
              _: 1
            })), [
              [_directive_permission, 'lbu_sale_coaching_edit_btn']
            ])
          : _createCommentVNode("", true),
        (props.type === 'view' && dataForm.value.status !== 2)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              onClick: confirmRow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 确认 ")
              ]),
              _: 1
            })), [
              [_directive_permission, 'lbu_sale_coaching_confirm_btn']
            ])
          : _createCommentVNode("", true),
        (
        props.type === 'view' &&
        dataForm.value.status === 2 &&
        !dataForm.value.actionResult &&
        _unref(shareInfo).getUserInfo().work_code === dataForm.value.mentor
      )
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 3,
              onClick: reviewRow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 回顾 ")
              ]),
              _: 1
            })), [
              [_directive_permission, 'lbu_sale_coaching_review_btn']
            ])
          : _createCommentVNode("", true),
        (props.type === 'view' && dataForm.value.status === 2)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 4,
              onClick: commentRow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 评论 ")
              ]),
              _: 1
            })), [
              [_directive_permission, 'lbu_sale_coaching_comment_btn']
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "formRef"])
  ], 64))
}
}

})